import i18n from "i18next";
import sprintf from 'i18next-sprintf-postprocessor';

i18n.use(sprintf).init({
	// we init with resources
	resources: {
		en: {
			translations: {
			}
		},
		fr: {
			translations: {
			}
		}
	},
	fallbackLng: "en",
	debug: false,

	// have a common namespace used around the full app
	ns: ["translations"],
	defaultNS: "translations",

	keySeparator: false, // we use content as keys

	interpolation: {
		escapeValue: false, // not needed for react!!
		formatSeparator: ","
	},

	react: {
		wait: true
	}
});

export default i18n;



// WEBPACK FOOTER //
// ./src/services/i18n.js